<template>
    <div id="globalSettings">
        <AppBreadCrumb :paths="[{ title: $t('message.globalSettings') }]" :select="true">
            <a-button class="actionButtonBreadcrumb" @click="showModal">
                <md-icon>add</md-icon>
                <span>{{ $t("message.addSetting") }}</span>
            </a-button>
        </AppBreadCrumb>

        <b-container fluid>
            <b-row>
                <b-col>
                    <a-table :columns="cols" :dataSource="settings" class="custom-table2">
                        <div slot="value" slot-scope="setting">
                            <input
                                v-model="settingsForm[setting._id]"
                                :placeholder="$t('message.optionsPlaceholder')"
                                style="border: none; width: 100%; background: bottom"
                                @change="
                                    setSetting({
                                        id: setting._id,
                                        value: settingsForm[setting._id],
                                    })
                                "
                            />
                        </div>
                        <div slot="actionsSlot" slot-scope="setting">
                            <div class="d-flex w-100 justify-content-center">
                                <a-button
                                    class="actionButton d-flex align-items-center"
                                    @click="deleteSetting(setting._id)"
                                >
                                    <span style="margin-right: 16px; display: block">{{ $t("message.delete") }}</span>
                                    <ActionDelete />
                                </a-button>
                                <a-button class="actionButton d-flex align-items-center" @click="editSetting(setting)">
                                    <span style="margin-right: 16px; display: block">{{ $t("message.edit") }}</span>
                                    <ActionEdit />
                                </a-button>
                            </div>
                        </div>
                    </a-table>
                </b-col>
                <b-col v-for="setting in settings" v-if="false" :key="setting._id" sm="4">
                    <md-button @click="deleteSetting(setting._id)"> {{$t("message.delete")}}</md-button>
                    <md-button @click="editSetting(setting)"> {{$t("message.edit")}}</md-button>
                    <span>{{ setting.key }}</span>
                    <span>{{ setting.type }}</span>
                    <md-field>
                        <md-input
                            v-model="settingsForm[setting._id]"
                            @change="
                                setSetting({
                                    id: setting._id,
                                    value: settingsForm[setting._id],
                                })
                            "
                        />
                    </md-field>
                </b-col>
            </b-row>
        </b-container>

        <Modal2 id="addSettingFieldForm" v-if="isModalShow" :show-footer="false" @cancel="hideModal">
            <b-form @submit.prevent="saveHandle">
                <!--        <b-input v-model="modal.key" :placeholder="$t('message.fieldName')" class="mb-1"/>-->
                <!--        <b-input v-model="modal.type" :placeholder="$t('message.contentType')"/>-->
                <div class="global-settings-form">
                    <h4>
                        {{ editMode ? $t("message.changeSettings") : $t("message.addNewSettings") }}
                    </h4>
                    <md-field
                        :class="{
                            'md-invalid': errors.items.find((x) => x.field == $t('message.fieldName')) !== undefined,
                        }"
                    >
                        <label> {{ $t("message.fieldName") }}</label>
                        <md-input
                            v-model="modal.key"
                            v-validate="'required'"
                            :name="$t('message.fieldName')"
                            autocomplete="off"
                        ></md-input>
                        <span class="md-error">{{
                            $t("message.fieldRequired", {
                                field: $t("message.fieldName"),
                            })
                        }}</span>
                    </md-field>
                    <md-field
                        :class="{
                            'md-invalid': errors.items.find((x) => x.field == $t('message.contentType')) !== undefined,
                        }"
                    >
                        <label> {{ $t("message.contentType") }}</label>
                        <md-select
                            v-model="modal.type"
                            v-validate="'required'"
                            :name="$t('message.contentType')"
                            autocomplete="off"
                        >
                            <md-option
                                v-for="(t, i) in ['string', 'number', 'boolean', 'array', 'object']"
                                :key="i"
                                :value="t"
                                >{{ t.charAt(0).toLocaleUpperCase() + t.substr(1, t.length) }}
                            </md-option>
                        </md-select>
                        <span class="md-error">{{
                            $t("message.fieldRequired", {
                                field: $t("message.contentType"),
                            })
                        }}</span>
                    </md-field>

                    <md-field>
                        <label> {{ $t("message.value") }}</label>
                        <md-input v-model="modal.value" :name="$t('message.value')" autocomplete="off"></md-input>
                    </md-field>

                    <md-button class="global-settings-submit md-primary" type="submit">
                        {{ $t("message.save") }}
                    </md-button>
                </div>
            </b-form>
        </Modal2>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import ActionEdit from "../../components/svg/ActionEdit";
import ActionDelete from "../../components/svg/ActionDelete";
import Vue from "vue";
import Modal2 from "../../components/common/Modal2.vue";

export default {
    name: "globalSettings",
    components: {
        AppBreadCrumb,
        ActionEdit,
        ActionDelete,
        Modal2,
    },
    data() {
        return {
            isModalShow: false,
            editMode: false,
            modal: {
                key: "",
                type: "",
                value: "",
            },
            settingsForm: {},
            cols: [
                {
                    dataIndex: "key",
                    title: this.$t("message.key"),
                    width: "25%",
                },
                {
                    dataIndex: "type",
                    title: this.$t("message.type"),
                    width: "25%",
                },
                {
                    scopedSlots: { customRender: "value" },
                    title: this.$t("message.value"),
                    width: "35%",
                },
                {
                    scopedSlots: { customRender: "actionsSlot" },
                    title: this.$t("message.transactions"),
                },
            ],
        };
    },
    computed: {
        ...mapState({
            loggedUser: (state) => state.auth.adminUser,
            adminUser: (state) => state.auth.adminUser,
            settings: (state) => state.globalSettings.globalSettings.settings,
        }),
    },
    methods: {
        ...mapActions({
            getSettings: "fetchSettings",
            newSetting: "newSetting",
            deleteSetting: "deleteSetting",
            setSetting: "setSetting",
            updateSetting: "updateSetting",
            getSetting: "getSetting",
        }),
        showModal() {
            this.isModalShow = true;
        },
        hideModal() {
            this.isModalShow = false;
            this.resetForm();
        },
        async saveHandle() {
            const validateResponse = await this.$validator.validateAll();
            if (validateResponse) {
                let data;
                if (!this.editMode) data = await this.newSetting(this.modal);
                else {
                    let { id, ...params } = this.modal;
                    data = await this.updateSetting({ id, params });
                }
                //this.settingsForm[data.data._id] = this.modal.value || "";

                Vue.set(this.settingsForm, data.data._id, this.modal.value || "");

                /*this.$bvModal.hide("addSettingFieldForm");*/
                this.hideModal();
                this.modal = {
                    key: "",
                    type: "",
                    value: "",
                };
                this.editMode = false;
            }
        },
        editSetting(setting) {
            this.editMode = true;
            this.modal = {
                id: setting._id,
                key: setting.key,
                type: setting.type,
                value: setting.value,
            };
            this.settingsForm[setting._id] = setting.value || "";
            /*this.$bvModal.show("addSettingFieldForm");*/
            this.showModal();
        },
        resetForm() {
            this.editMode = false;
            this.modal = {
                type: "",
                key: "",
                value: "",
            };
        },
    },
    mounted() {
        this.getSettings().then(() => {
            this.settingsForm = this.settings.reduce((acc, cur) => {
                acc[cur._id] = cur.value || "";
                return acc;
            }, {});
        });
    },
    beforeMount() {
        const isAccessEnabled =
            this.loggedUser.isFullAccess || this.loggedUser.approvedPages.some((page) => page.page === "global-settings");
        if (!isAccessEnabled) {
            this.$router.push("/denied");
        }
    },
};
</script>

<style lang="scss" scoped>
#globalSettings {
    .actionButton {
        border: none;
        box-shadow: none;
    }

    .global-settings-form {
        display: flex;
        flex-direction: column;
        position: relative;

        .global-settings-submit {
            position: absolute;
            right: 0;
        }
    }
}
</style>

<style>
.md-select-menu {
    z-index: 9999999999999999999999 !important;
}
</style>
